import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import pb from '../lib/pocketbase';
import './Hero.css';

const Hero = () => {
    // Initialize with cached image if available, otherwise default
    const [bgImage, setBgImage] = useState(() => {
        return localStorage.getItem('hero_image_cache') || '/images/hero_terrace.jpg';
    });

    useEffect(() => {
        const fetchHeroImage = async () => {
            try {
                const records = await pb.collection('settings').getList(1, 1);
                if (records.items.length > 0 && records.items[0].heroImage) {
                    const record = records.items[0];
                    const newUrl = pb.files.getURL(record, record.heroImage);

                    // Update state and cache
                    setBgImage(newUrl);
                    localStorage.setItem('hero_image_cache', newUrl);
                }
            } catch (err) {
                // Keep current if fail
            }
        };
        fetchHeroImage();
    }, []);

    return (
        <section id="accueil" className="hero" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', transition: 'background-image 0.5s ease-in-out' }}>
            <div className="hero-overlay"></div>
            <div className="container hero-content">
                <h1 className="hero-title animate-fade-in">
                    Patisserie Fine <br />
                    <span className="text-gold">Cedric Millet</span>
                </h1>
                <p className="hero-subtitle animate-fade-in">
                    Une vision unique de la pâtisserie à Albi. <br />
                    Équilibre, saisonnalité et gourmandise.
                </p>
                <div className="hero-btn-container animate-fade-in">
                    <Link to="/gateaux" className="btn">Découvrir nos pâtisseries</Link>
                </div>
            </div>
        </section>
    );
};

export default Hero;
